<template>
  <RouterView />
</template>

<script setup lang="ts">
import { useGlobalStore } from './stores/global-store'
import { useI18n } from 'vue-i18n'
import { useColors } from 'vuestic-ui'

const { applyPreset } = useColors()

const { locale } = useI18n()

const globalStore = useGlobalStore()

// Apply theme from store on load
applyPreset(globalStore.theme)

locale.value = globalStore.language
</script>

<style lang="scss">
@import 'scss/main.scss';

#app {
  font-family: 'Inter', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  margin: 0;
  min-width: 20rem;
}
</style>
